/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'search-button.scss' instead.
import { css } from 'lit';
export default css `:host button{text-decoration:none!important}:host ::slotted([class=search-icon]){--icon-height:var(--cipublic-icon-height, 1rem);--icon-width:var(--cipublic-icon-width, 1rem)}`;
//# sourceMappingURL=search-button.scss.js.map